module.exports = __webpack_public_path__ + "img/bloodrite-large.073cb1ce.png";